import { useCallback } from 'react';

import type { DeepPartial } from '@luna/utils-ts';
import { logger } from '@luna/logger';

import type { FrontendUserConfiguration } from './UserConfigurationTypes';
import {
    useDeprecatedUpdateUserConfiguration,
    useDeprecatedUserConfiguration,
} from './UserConfiguration';

const FRONTEND_CONFIG_ID = 'frontend';

/** @deprecated - Do not use the configuration as a key value store. */
export const useDeprecatedFrontendUserConfiguration = () => {
    const { entity: frontendUserConfiguration, isPending } =
        useDeprecatedUserConfiguration(FRONTEND_CONFIG_ID);
    const {
        updateById,
        isPending: isUpdatePending,
        data: updateData,
        reset: resetUpdate,
    } = useDeprecatedUpdateUserConfiguration();

    const updateUserConfiguration = useCallback(
        (userConfiguration: DeepPartial<FrontendUserConfiguration>) =>
            updateById({
                id: FRONTEND_CONFIG_ID,
                changes: userConfiguration,
            }).catch((e) => logger.error('Failed to update user configuration', e)),
        [updateById],
    );

    return {
        userConfiguration: frontendUserConfiguration as FrontendUserConfiguration | undefined,
        isPending,
        isUpdatePending,
        updateData,
        resetUpdate,
        updateUserConfiguration,
    };
};
